import axios from "axios";
import http from "./httpService";

const auth = axios.create({
  headers: {
    "Content-type": "application/json",
  },
});

class AuthService {
  async validateToken(token) {
    return await auth.get(
      `${process.env.VUE_APP_LOGIN_URL}/validate-token/${token}`
    );
  }

  async login(data) {
    return await http.post("/auth/login", data);
  }

  async register(data) {
    return await http.post("/auth/register", data);
  }

  async forgotPassword(data) {
    return await http.post("/auth/user/reset-password", data);
  }

  async resetPassword(otp, data) {
    return await http.put(`/auth/user/reset-password/${otp}`, data);
  }

  async verifyOtp(otp, email) {
    return await http.post(`/auth/verify-otp-token`, {
      otp,
      email,
    });
  }

  async verifyPasswordResetOTP(otp, email) {
    return await http.put(`/auth/user/reset-password/${otp}`, {
      email,
    });
  }

  async resendVerificationEmail(email) {
    return await http.post("/auth/request-verification", { email });
  }

  async verifyEmail(otp, email) {
    return await http.put(`/auth/verify/${otp}`, {
      email,
    });
  }

  async changePassword(data) {
    return await http.put("/profile/change-password", data);
  }

  async guestLogin(data) {
    return await http.post("/auth/guest-login", data);
  }
}

export default new AuthService();
